import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-city-master',
  templateUrl: './city-master.component.html',
  styleUrls: ['./city-master.component.css']
})
export class CityMasterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
